import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ResourceDetailsBaseComponent } from '../resource-details-base/resource-details-base.component';

@Component({
    selector: 'app-resource-details-survey',
    templateUrl: './resource-details-survey.component.html',
    styleUrls: ['./resource-details-survey.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResourceDetailsSurveyComponent extends ResourceDetailsBaseComponent {
    constructor() {
        super();
    }
}
